var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNavegaciNPropiedades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.75.25v3h-1.5v-1.5h-7.5v16.5h4.5v-6.44l-1.44 1.441-1.061-1.06L13 2.939l9.251 9.252-1.06 1.06-1.441-1.44v7.939H14.5l-.005-6h-2.994v6H.25V.25h10.5zM13 5.06l-5.25 5.25v7.94H10v-6h5.994l.005 6h2.251v-7.939L13 5.061zM5.503 6.25v1.5H3.25v-1.5h2.253zm-.01-3v1.5H3.25v-1.5h2.243z",
    transform: "translate(-865 -485) translate(865 485) translate(1 2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavegaciNPropiedades);
export default __webpack_public_path__ + "static/media/icons-navegaci-n-propiedades.c4719b25.svg";
export { ForwardRef as ReactComponent };